import React, { useEffect, useState } from "react";
import './styles.scss';
import LOGO_COLOR from 'assets/images/logo-color.png';
import LOGO_WHITE from 'assets/images/logo-white.png';
import Button from "components/button";
import DATA from 'utils/data.json';

const Header = () => {
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const onMenuItemClick = (item) => {
        let el = document.getElementById(item.link)
        if (el) {
            if (item.link === 'teacher-id') {
                window.scrollTo({left: 0, top: el.offsetTop - (92 + 20) + 300, behavior: 'smooth'})
            } else {
                window.scrollTo({left: 0, top: el.offsetTop - (92 + 20), behavior: 'smooth'})
            }
        }
    }

    return (
        <header className="header container" style={{backgroundColor: `rgba(252, 252, 253, ${(offset / 400)})` }} >
            <div className={'logo'}>
                <a href="/">
                    <img alt="" src={LOGO_WHITE} style={{ opacity: 1 - (offset / 400) }} />
                    <img alt="" src={LOGO_COLOR} style={{ opacity: offset / 200 }} />
                </a>
            </div>
            <div className={'navbar'}>
                {DATA['nav-item'].map(item => {
                    return (
                        <button key={item.id} onClick={() => onMenuItemClick(item)}>
                            {offset < 200 ? <p className={'item'}>{item.text}</p> : <p className={'item-black'}>{item.text}</p>}
                        </button>
                    )
                })}
            </div>
            <Button className="button" href={DATA['form']} type="primary" content="Đăng ký ngay"/>
        </header>
    )
}

export default Header;